export const clearClientStorage = (): void => {
  localStorage.clear();
  sessionStorage.clear();
  const cookies = document.cookie.split(';').map((v) => v.trim());
  for (let i = 0, len = cookies.length; i < len; i++) {
    document.cookie = `${cookies[i]}=;expires=${new Date(0).toUTCString()}`;
  }
};
